import { useEffect, useState } from 'react'

import { roomKeys } from 'helpers/events'

import useVideoContext from '../useVideoContext/useVideoContext'

/*
  Returns the participant that is sharing their screen (if any). This hook assumes that only one participant
  can share their screen at a time.
*/
export default function useScreenShareParticipant() {
    const { room } = useVideoContext()
    const [screenShareParticipant, setScreenShareParticipant] = useState()

    useEffect(() => {
        if (room.state === 'connected') {
            const updateScreenShareParticipant = () => {
                setScreenShareParticipant(
                    Array.from(room.participants.values())
                        // the screenshare participant could be the localParticipant
                        .concat(room.localParticipant)
                        .find(participant =>
                            Array.from(
                                participant.tracks.values()
                            ).find(track => track.trackName.includes('screen'))
                        )
                )
            }
            updateScreenShareParticipant()

            room.addListener(
                roomKeys.TRACK_PUBLISHED,
                updateScreenShareParticipant
            )
            room.addListener(
                roomKeys.TRACK_UNPUBLISHED,
                updateScreenShareParticipant
            )
            room.addListener(
                roomKeys.PARTICIPANT_DISCONNECTED,
                updateScreenShareParticipant
            )
            // the room object does not emit 'trackPublished' events for the localParticipant,
            // so we need to listen for them here.
            room.localParticipant.addListener(
                'trackPublished',
                updateScreenShareParticipant
            )
            room.localParticipant.addListener(
                'trackUnpublished',
                updateScreenShareParticipant
            )
            return () => {
                room.removeListener(
                    roomKeys.TRACK_PUBLISHED,
                    updateScreenShareParticipant
                )
                room.removeListener(
                    roomKeys.TRACK_UNPUBLISHED,
                    updateScreenShareParticipant
                )
                room.removeListener(
                    roomKeys.PARTICIPANT_DISCONNECTED,
                    updateScreenShareParticipant
                )
                room.localParticipant.removeListener(
                    'trackPublished',
                    updateScreenShareParticipant
                )
                room.localParticipant.removeListener(
                    'trackUnpublished',
                    updateScreenShareParticipant
                )
            }
        }
    }, [room])

    return screenShareParticipant
}
